module.exports = __webpack_public_path__ + "static/img/nals-app-icon.47cfe7f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/projects/nals/nals-app-icon.jpg
// module id = D2LR
// module chunks = 0